import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageHeader from "../../../../components/PageHeader";
import HowItWorksButton from "../../../../components/howItWorks/HowItWorksButton";
import Address from "../../../address/Address";

const SettingsSitesList = ({ token, API, basePath }) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className="settings-page-wrapper">
      <PageHeader
        title={t("Sites")}
        showBackButton={true}
        backRoute="/settings"
        backLabel={t("settingsSites.backToSettings")}
        helpButton={<HowItWorksButton topic="sites" />}
      />
      <div className="settings-content-wrapper">
        <div className="settings-list-shell">
          <Address
            token={token}
            API={API}
            onCreateSite={() => history.push(`${basePath}/new`)}
            onOpenSite={(site) => history.push(`${basePath}/${site._id}`)}
          />
        </div>
      </div>
    </div>
  );
};

export default SettingsSitesList;
